<template>
  <div>
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Contact'
    }
  }
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue